import React  from 'react'

import BreadcrumbsCustom, {
    BreadcrumbElement
} from "../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"

type Props = {
    breadcrumbItems?: BreadcrumbElement[]
}

export default function QuickAdd_BreadcrumbNavigation(props: Props) {
    if (!props.breadcrumbItems) return null

    return (
        <div className="new-form-title">
            <div className="flex-row-left-center p-l-35">
                <BreadcrumbsCustom breadcrumbItems  = {props.breadcrumbItems}
                                   highlightOnHover = {true}/>
            </div>
        </div>
    )
}